import { generate } from '../../../core/js/utils/componentUtils';
import { getDefaultOptions } from '../../../core/js/utils/a15componentUtils';
import addDropdownSupport from '../../../core/js/uiSupport/dropDown';
import { getFlatNavigationSync } from '@core/js/utils/navigationUtils';

import template from 'help-navigation.j2';

function afterConstruction() {
    addDropdownSupport(this, this.scopedSelector('.js-dropdown-container'));
}

function beforeRender(store) {
    getFlatNavigationSync(store);
}

function onStateChange(store, watchValue, newValue, oldValue) {
    this.render(store, this);
    addDropdownSupport(this, this.scopedSelector('.js-dropdown-container'));
}

/**
 * Bootstrap the component onto the page
 * @param {object} store The redux store
 * @param {object} overrides Component-level overrides config
 * @returns {undefined}
 */
export function init(store, overrides = {}) {
    const config = {
        watch: ['core.deviceCharacteristics'],
        name: 'helpNavigationComponent',
        beforeRender: beforeRender,
        afterConstruction: afterConstruction,
        onStateChange: onStateChange,
        templateLocation: '.dom-help-navigation',
        template: template
    };

    return generate(config, store, overrides, getDefaultOptions(store));
}
